import React from 'react'
import '../styles/ArtworkStyle.css'

function Fullscreen({source, onClose}) {

  const handleClickOutside = (e) => {
    if (e.target === e.currentTarget) { // Checks if click is on the backdrop
      onClose();
    }
  };

  return (
      <div id='fullscreenImage'>
        if(isFullscreen) {
    <>
    <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)', // Dark semi-transparent
          zIndex: 1000, // Above other content
        }}
        onClick={handleClickOutside}
      />
    <img src={source} alt='' id='imgFullscreen'/>
    </>
        } else {
        <img src={source} alt='' id='imgHidden'/>
}
    </div>
  )
}

export default Fullscreen
